<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin:2%">
        <div>
            <label class="page-header-title">Pricing</label>
        </div>

    </div>
    <mat-card fxLayout="column" style="margin: 2% 3% 0% 2%" fxLayoutAlign="start center">
        <div fxLayout="column">
            <div fxLayoutAlign="start center" class="pricing-title">
                <label class="pricing-label">Pricing</label>

            </div>
            
            <div fxLayoutAlign="center center">
                <label class="pricing-sub-label" (click)="goToLink('https://swiftchat.ai/swiftchatbusinessapi/billing/')">Billing</label>
            </div>
            
        </div>

    </mat-card>

</div>
